import React from "react";
import styles from "../labReportPdf.module.scss";

const MalariaParasiteICT = ({ profile, PageBaseLayout, PageFooter }) => {
  return (
    <div className={styles.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout showSampleType={true} currentSampleType={profile.sampleType} />
      <div className={styles.testCategoryHeader}>
        {profile?.profileName?.toUpperCase()}
      </div>

      <table className={styles.resultsTable}>
        <thead>
          <tr>
            <th style={{ width: "45%" }}>Test Description</th>
            <th style={{ textAlign: "center", width: "20%" }}>Value(s)</th>
            <th style={{ textAlign: "center", width: "15%" }}>Unit(s)</th>
            <th style={{ textAlign: "center", width: "20%" }}>
              Reference Range
            </th>
          </tr>
        </thead>
        <tbody>
          {profile?.tests?.map((t, idx) => (
            <tr key={idx}>
              <td>
                <strong>{t.testName}</strong>
              </td>
              <td align="center">
                <span
                  style={{
                    fontWeight:
                      t.value?.toLowerCase().includes("positive") ||
                      t.value?.toLowerCase().includes("seen")
                        ? "900"
                        : "normal",
                  }}
                >
                  {t.value || "-"}
                </span>
              </td>
              <td align="center">{t.units || "-"}</td>
              <td align="center">{t.reference_range_details || "Negative"}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* <div
        style={{
          marginTop: "20px",
          fontSize: "11px",
          border: "1px solid #eee",
          padding: "10px",
        }}
      > */}
      {/* <strong>Note:</strong> */}
      {/* <ul style={{ margin: "5px 0", paddingLeft: "15px" }}>
          <li>
            ICT is a screening test; results should be correlated with
            peripheral smear examination.
          </li>
          <li>
            A single negative result does not strictly exclude malaria
            infection.
          </li>
        </ul> */}
      {/* </div> */}

      <PageFooter />
    </div>
  );
};

export default MalariaParasiteICT;
